<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { isMobile } from 'mobile-device-detect'
  import { wrapIframes } from '@/helper'

  export default {
    name: 'EditorModule',
    props: {
      options: {
        type: Object,
        default: _ => {},
      },
    },
    data() {
      return {
        isMobile: isMobile,
      }
    },
    methods: {
      wrapIframes,
    },
  }
</script>
